export default __webpack_public_path__ + "static/media/g-6.be8720ef.jpg";